import React from "react";
import Space from "antd/lib/space";
import styled from "styled-components";
import { AppButton } from "components/button";
import { ButtonType } from "components/button/appButton";
import { CircleIndicator } from "components/circleIndicator";
import { Task } from "./tasks";

interface Props {
  task: Task;
  updateStatus: (taskId: string, status: Task["status"]) => void;
  userRole: string;
}

export const PatientDetail: React.FC<Props> = ({
  task,
  updateStatus,
  userRole
}) => {
  const disabled = userRole !== task.implementorRole;

  const statusColors: any = {
    "Not Started": { inner: "#F31F13", outer: "#FBBBB8" },
    "In Progress": { inner: "#DD951F", outer: "#FCE5C6" },
    Completed: { inner: "#04A468", outer: "#B3E4D1" }
  };

  return (
    <Container>
      <Title>{task.taskName}</Title>

      <Description>{task.description}</Description>

      <StatusRow>
        <StatusText>Current Status: </StatusText>
        <CircleIndicator
          outerColor={statusColors[task.status].outer}
          innerColor={statusColors[task.status].inner}
        />
        <StatusText>{task.status}</StatusText>
      </StatusRow>

      <Space style={{ marginTop: 20 }}>
        {task.status === "Not Started" && (
          <AppButton
            type={ButtonType.Primary}
            buttonContent="Start Task"
            disabled={disabled}
            onClick={() => updateStatus(task.id, "In Progress")}
          />
        )}

        {task.status === "In Progress" && (
          <AppButton
            type={ButtonType.Primary}
            buttonContent="Complete Task"
            disabled={disabled}
            onClick={() => updateStatus(task.id, "Completed")}
          />
        )}
      </Space>

      {disabled && (
        <Note>Only {task.implementorRole} can perform this task</Note>
      )}
    </Container>
  );
};

const Container = styled.div`
  padding: 30px;
  max-width: 800px;
`;

const Title = styled.h2`
  font-weight: 600;
  margin-bottom: 10px;
`;

const Description = styled.p`
  margin-top: 10px;
  color: #555;
  line-height: 1.6;
`;

const StatusRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
`;

const StatusText = styled.span`
  font-weight: 600;
  font-size: 15px;
`;

const Completed = styled.div`
  color: #04a468;
  font-weight: 600;
  font-size: 15px;
`;

const Note = styled.div`
  margin-top: 15px;
  color: #ff4d4f;
  font-size: 13px;
`;
